import React, { useState } from "react";
import Refuse from "./refuse";
import Approve from "./approve";

function ReportCameraDetailsModal({ selectedReport, adminName }) {
  const [zoomedImage, setZoomedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [targetCars, setTargetCars] = useState("");

  const date = new Date(selectedReport?.date);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const combinedMedia = [
    ...(selectedReport?.photos || []),
    ...(selectedReport?.videos || []),
  ];

  const isVideo = (media) => {
    if (!media || typeof media !== "string") return false;
    const lower = media.split("?")[0].toLowerCase();
    return (
      lower.endsWith(".mp4") ||
      lower.endsWith(".avi") ||
      lower.endsWith(".mov")
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + combinedMedia.length) % combinedMedia.length);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % combinedMedia.length);
  };

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl rounded-2xl bg-white p-6 shadow-xl">
          {/* Header */}
          <div className="mb-4 flex items-center justify-between">
            <h3 className="w-full text-center text-lg font-bold text-brand-500">
              Detajet e raportit #{selectedReport?.reportName}
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm bg-white text-brand-700 hover:text-white"
              onClick={() => setZoomedImage(null)}
            >
              ✕
            </label>
          </div>
          <hr />

          {/* 📌 Report Information */}
          <div className="mt-4 space-y-3">
            <p>
              <span className="font-bold">Institucioni:</span>{" "}
              {selectedReport?.institution || "N/A"}
            </p>

            <p>
              <span className="font-bold">Qyteti:</span>{" "}
              {selectedReport?.address || "Unknown"}
            </p>

            <p>
              <span className="font-bold">Kategoria:</span>{" "}
              {selectedReport?.category}
            </p>

            <p>
              <span className="font-bold">Data:</span> {formattedDate}
            </p>

            <p className="break-words">
              <span className="font-bold">Përshkrimi:</span>{" "}
              {selectedReport?.textContent || "N/A"}
            </p>
          </div>

          {/* Media Carousel */}
          {combinedMedia.length > 0 && (
            <div className="relative mx-auto mt-6 flex max-w-2xl items-center justify-center">
              <div className="relative">
                {isVideo(combinedMedia[currentIndex]) ? (
                  <video
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full rounded-lg object-contain shadow"
                    controls
                  />
                ) : (
                  <img
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                    alt={`media-${currentIndex + 1}`}
                    onClick={() => setZoomedImage(combinedMedia[currentIndex])}
                  />
                )}

                {/* Watermark */}
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
                  <span
                    className="font-bold text-white/30 break-words"
                    style={{
                      transform: "rotate(-45deg)",
                      width: "90%",
                      textAlign: "center",
                      fontSize: "clamp(14px, 4vw, 50px)",
                      lineHeight: "1.1",
                    }}
                  >
                    {adminName}
                  </span>
                </div>
              </div>

              {/* Arrows */}
              {combinedMedia.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❮
                  </button>
                  <button
                    onClick={nextSlide}
                    className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          )}

          {/* Target Cars */}
          {/* <div className="mt-6">
            <label className="mb-1 block text-sm font-medium text-gray-700">
              Targat e makines
            </label>
            <input
              type="text"
              value={targetCars}
              onChange={(e) => setTargetCars(e.target.value)}
              placeholder="Shënoni targat (p.sh., ABC-123)"
              className="w-full rounded-lg border border-gray-300 p-2 focus:border-brand-500 focus:ring focus:ring-brand-200"
            />
          </div> */}

          {/* Footer */}
          <footer className="modal-action mt-6 flex justify-end gap-2">
            <label
              htmlFor="my-modal-5"
              className="btn border-0 bg-white text-brand-700 hover:text-white"
            >
              Kthehu
            </label>

            {/* Refuse */}
            <label
              htmlFor="my-modal-6"
              className="btn border-0 bg-red-500 text-white hover:bg-red-600"
            >
              Refuzo
            </label>
            <Refuse id={selectedReport?.id} />

            {/* Approve */}
            <Approve id={selectedReport?.id} targetCars={targetCars}>
              {(sendApproval) => (
                <button
                  onClick={sendApproval}
                  className="btn border-0 bg-brand-500 text-white hover:bg-brand-700"
                >
                  Aprovo
                </button>
              )}
            </Approve>
          </footer>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>

          <div className="relative">
            {isVideo(zoomedImage) ? (
              <video
                src={zoomedImage}
                className="max-h-full max-w-full rounded-lg object-contain shadow-lg"
                controls
              />
            ) : (
              <img
                src={zoomedImage}
                className="max-h-full max-w-full rounded-lg object-contain shadow-lg"
                alt="Zoomed Media"
              />
            )}

            {/* Watermark */}
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
              <span
                className="font-bold text-white/30 break-words"
                style={{
                  transform: "rotate(-45deg)",
                  width: "90%",
                  textAlign: "center",
                  fontSize: "clamp(14px, 4vw, 50px)",
                }}
              >
                {adminName}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReportCameraDetailsModal;
